import { ClipboardList, ExternalLink, ShieldCheck } from "lucide-react";

const KEGIATAN_URL = "https://bit.ly/LinkKegiatanIrbansusKabTsm";

// Halaman ini berada di belakang ProtectedRoute (login + 2FA wajib),
// sehingga gate password bersama yang lama sudah tidak diperlukan.
export default function KegiatanIrbansus() {
  const handleOpenLink = () => {
    window.open(KEGIATAN_URL, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="space-y-5" data-testid="kegiatan-irbansus-page">
      {/* Header */}
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-[#1e3a5f] to-[#2d5a8e] shadow-md shadow-[#1e3a5f]/20">
          <ClipboardList className="h-5 w-5 text-white" strokeWidth={2} />
        </div>
        <div>
          <h1 className="font-display text-2xl font-bold text-slate-900 md:text-3xl">
            Kegiatan Irbansus
          </h1>
          <p className="text-xs text-slate-500 mt-0.5">
            Akses data kegiatan Irbansus Kab. Tasikmalaya
          </p>
        </div>
      </div>

      {/* Main content card */}
      <div className="rounded-2xl border border-slate-200/60 bg-white/80 backdrop-blur-xl shadow-lg shadow-slate-200/30 overflow-hidden">
        {/* Info banner */}
        <div className="bg-gradient-to-r from-emerald-50 to-teal-50 border-b border-emerald-100 px-6 py-4">
          <div className="flex items-center gap-3">
            <div className="flex h-9 w-9 items-center justify-center rounded-full bg-emerald-100">
              <ShieldCheck className="h-5 w-5 text-emerald-600" />
            </div>
            <div>
              <div className="text-sm font-semibold text-emerald-800">Akses Terlindungi</div>
              <div className="text-xs text-emerald-600">
                Halaman ini hanya dapat diakses setelah login dengan verifikasi dua langkah.
              </div>
            </div>
          </div>
        </div>

        {/* Link section */}
        <div className="p-6 sm:p-8">
          <div className="rounded-xl border border-slate-100 bg-slate-50/50 p-5">
            <div className="text-xs font-semibold uppercase tracking-wider text-slate-400 mb-3">
              Link Kegiatan
            </div>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium text-slate-700 truncate">
                  Link Kegiatan Irbansus Kab. Tasikmalaya
                </div>
                <div className="text-xs text-slate-400 mt-0.5 truncate">
                  {KEGIATAN_URL}
                </div>
              </div>
              <button
                onClick={handleOpenLink}
                className="shrink-0 flex items-center gap-2 rounded-xl bg-gradient-to-r from-[#1e3a5f] to-[#2d5a8e] px-5 py-2.5 text-sm font-semibold text-white shadow-md shadow-[#1e3a5f]/20 transition-all hover:shadow-lg hover:shadow-[#1e3a5f]/30 hover:brightness-110"
                data-testid="kegiatan-open-link-btn"
              >
                <ExternalLink className="h-4 w-4" />
                Buka Link
              </button>
            </div>
          </div>

          <p className="mt-4 text-xs text-slate-400 leading-relaxed">
            Klik tombol "Buka Link" untuk membuka data kegiatan di tab baru.
          </p>
        </div>
      </div>
    </div>
  );
}
